import type { QueryKey } from '@tanstack/react-query';
import { MutationCache, QueryClient, matchQuery } from '@tanstack/react-query';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      invalidates?: Array<QueryKey>;
    };
  }
}

export const createCustomQueryClient = () => {
  const queryConfig = {
    queries: {
      retry: 1,
    },
  };

  const mutationCache = new MutationCache({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onError: (error: unknown, _variables, _context) => {
      console.error(error);
    },
    onSuccess: (_data, _variables, _context, mutation) => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          // invalidate all matching tags at once
          // or everything if no meta is provided
          mutation.meta?.invalidates?.some((queryKey) => matchQuery({ queryKey }, query)) ?? true,
      });
    },
  });

  const queryClient = new QueryClient({
    defaultOptions: queryConfig,
    mutationCache,
  });

  return queryClient;
};

export const defaultQueryClient = createCustomQueryClient();
